import React from "react";
import styles from "./admin.module.scss";
import Button from "./Button";

interface SaveBarProps {
  /** Only rendered when true. */
  visible: boolean;
  onSave?: () => void;
  onDiscard: () => void;
  saving?: boolean;
  message?: React.ReactNode;
  saveLabel?: string;
  /** Set to "submit" to let a surrounding form handle saving. */
  saveType?: "button" | "submit";
}

const SaveBar: React.FC<SaveBarProps> = ({
  visible,
  onSave,
  onDiscard,
  saving,
  message = "Du har ulagrede endringer",
  saveLabel = "Lagre endringer",
  saveType = "button",
}) => {
  if (!visible) return null;
  return (
    <div className={styles.sticky}>
      <div
        className={styles.savebar}
        role="region"
        aria-label="Ulagrede endringer"
      >
        <span className={styles.savebarDot} aria-hidden="true" />
        {message}
        <span className={styles.savebarActs}>
          <Button
            variant="ghost"
            className={styles.savebarGhost}
            onClick={onDiscard}
            disabled={saving}
          >
            Forkast
          </Button>
          <Button
            variant="mint"
            type={saveType}
            onClick={onSave}
            loading={saving}
          >
            {saveLabel}
          </Button>
        </span>
      </div>
    </div>
  );
};

export default SaveBar;
